export const formatDate = (date: string | Date) => {
  return new Date(date).toLocaleDateString().replace(/\//g, ".");
};

export const replacePostfix = (str: string) => {
  return str.replace(/\s*г\./, "");
};
